import Vue from "vue";
import ApiService from "../../services/ApiService";
import { mapGetters } from "vuex";

const $ = require("jquery");

Vue.component("team-impact-display", {
  props: {
    referenceType: {
      type: String,
      default: "item",
    },
    referenceId: {
      type: Number,
      required: true,
    },
    showTitle: {
      type: Boolean,
      default: false,
    },
    itemData: {
      type: Object,
      default: null,
    },
    // Neue Props für initiale Daten aus Item-Properties
    initialRating1: {
      type: Number,
      default: null,
    },
    initialRating2: {
      type: Number,
      default: null,
    },
    initialRating3: {
      type: Number,
      default: null,
    },
    initialRating4: {
      type: Number,
      default: null,
    },
    initialRating5: {
      type: Number,
      default: null,
    },
  },

  data() {
    return {
      rating1: 0,
      rating2: 0,
      rating3: 0,
      rating4: 0,
      rating5: 0,
      total: 0,
      average: 0,
      userRating: null,
      isLoading: false,
    };
  },

  computed: {
    ...mapGetters(["isLoggedIn"]),
    
    ratingLabels() {
      return {
        1: { text: "Schwächung", icon: "fa-arrow-down", color: "danger" },
        2: { text: "Kaum Effekt", icon: "fa-minus", color: "warning" },
        3: { text: "Kaderbreite", icon: "fa-users", color: "info" },
        4: { text: "Klare Verstärkung", icon: "fa-arrow-up", color: "success" },
        5: { text: "Gamechanger", icon: "fa-star", color: "primary" },
      };
    },
    
    hasRatings() {
      return this.total > 0;
    },
    
    itemURL() {
      if (!this.itemData) return "#";
      
      // Verwende den itemURL Filter wenn verfügbar
      if (this.$options.filters && this.$options.filters.itemURL) {
        const urlWithVariationId = !this.$ceres?.config?.item?.showPleaseSelect || 
                                    this.$ceres?.initialPleaseSelect === 0;
        return this.$options.filters.itemURL(this.itemData, urlWithVariationId);
      }
      
      return "#";
    },
  },

  watch: {
    isLoggedIn(newVal) {
      if (newVal && this.initialRating1 !== null) {
        // User hat sich eingeloggt, lade seine Bewertung
        this.loadUserRating();
      }
    },
  },

  mounted() {
    // Prüfe ob initiale Daten als Props übergeben wurden
    if (this.initialRating1 !== null && 
        this.initialRating2 !== null && 
        this.initialRating3 !== null && 
        this.initialRating4 !== null && 
        this.initialRating5 !== null) {
      // Nutze die übergebenen Daten, KEIN API-Call nötig
      this.rating1 = this.initialRating1;
      this.rating2 = this.initialRating2;
      this.rating3 = this.initialRating3;
      this.rating4 = this.initialRating4;
      this.rating5 = this.initialRating5;
      
      // Berechne Total und Average
      this.total = this.rating1 + this.rating2 + this.rating3 + this.rating4 + this.rating5;
      
      if (this.total > 0) {
        const sum = (1 * this.rating1) + (2 * this.rating2) + (3 * this.rating3) + 
                    (4 * this.rating4) + (5 * this.rating5);
        this.average = parseFloat((sum / this.total).toFixed(2));
      }
      
      // Wenn User eingeloggt ist, lade seine persönliche Bewertung
      if (this.isLoggedIn) {
        this.loadUserRating();
      }
    } else {
      // Keine initialen Daten vorhanden (sehr selten), lade via API
      this.loadRatings();
    }
  },

  methods: {
    loadUserRating() {
      if (!this.isLoggedIn) {
        return;
      }

      ApiService.get("/rest/fanliebling/team-impact", {
        referenceType: this.referenceType,
        referenceId: this.referenceId,
      })
        .done((response) => {
          const data = response.data || response;
          this.userRating = data.userRating || null;
        })
        .fail((error) => {
          // Stiller Fehler
          console.error("Team Impact User Rating Load Error:", error);
        });
    },
    
    loadRatings() {
      this.isLoading = true;

      ApiService.get("/rest/fanliebling/team-impact", {
        referenceType: this.referenceType,
        referenceId: this.referenceId,
      })
        .done((response) => {
          const data = response.data || response;

          this.rating1 = parseInt(data.rating1) || 0;
          this.rating2 = parseInt(data.rating2) || 0;
          this.rating3 = parseInt(data.rating3) || 0;
          this.rating4 = parseInt(data.rating4) || 0;
          this.rating5 = parseInt(data.rating5) || 0;
          this.total = parseInt(data.total) || 0;
          this.average = parseFloat(data.average) || 0;
          this.userRating = data.userRating || null;
        })
        .fail((error) => {
          console.error("Team Impact Display Load Error:", error);
        })
        .always(() => {
          this.isLoading = false;
        });
    },
    
    getAverageLabel() {
      if (this.average === 0) return "";
      
      const counts = [
        { rating: 1, count: this.rating1 },
        { rating: 2, count: this.rating2 },
        { rating: 3, count: this.rating3 },
        { rating: 4, count: this.rating4 },
        { rating: 5, count: this.rating5 },
      ];
      
      const maxCount = Math.max(...counts.map(c => c.count));
      const topRatings = counts.filter(c => c.count === maxCount && c.count > 0);
      
      if (topRatings.length > 1) {
        return 'Unentschlossen';
      }
      
      if (topRatings.length === 1) {
        return this.ratingLabels[topRatings[0].rating].text;
      }
      
      const rounded = Math.round(this.average);
      const label = this.ratingLabels[rounded];
      return label ? label.text : "";
    },
    
    getAverageColor() {
      if (this.average === 0) return "secondary";
      
      const counts = [
        { rating: 1, count: this.rating1 },
        { rating: 2, count: this.rating2 },
        { rating: 3, count: this.rating3 },
        { rating: 4, count: this.rating4 },
        { rating: 5, count: this.rating5 },
      ];
      
      const maxCount = Math.max(...counts.map(c => c.count));
      const topRatings = counts.filter(c => c.count === maxCount && c.count > 0);
      
      if (topRatings.length > 1) {
        return "warning";
      }
      
      if (topRatings.length === 1) {
        return this.ratingLabels[topRatings[0].rating].color;
      }
      
      const rounded = Math.round(this.average);
      const label = this.ratingLabels[rounded];
      return label ? label.color : "secondary";
    },
  },

  render: function(h) {
    return h("div", { class: "team-impact-display mb-3" }, [
      this.showTitle
        ? h("div", { 
            class: "team-impact-title"
          }, [
            h("div", {
              class: "title-text"
            }, "Wie sehr verbessert er das Team?"),
            h("a", {
              attrs: {
                href: this.itemURL
              },
              class: "team-impact-title-link"
            }, "(Gerüchteseite: Bewerten)")
          ])
        : null,
        
      // Wenn keine Bewertungen vorhanden - Kompakter Hinweis
      this.total === 0 
        ? h("a", {
            attrs: {
              href: this.itemURL
            },
            class: "team-impact-no-ratings"
          }, [
            h("small", { 
              class: "text-muted no-ratings-text"
            }, [
              h("i", {
                class: "fa fa-info-circle"
              }),
              "Noch keine Bewertungen"
            ]),
            h("small", {
              class: "text-muted team-impact-cta"
            }, "Bewerten")
          ])
        : null,
      
      // Wenn Bewertungen vorhanden - Nur Stats (keine Balken)
      this.total > 0
        ? h("div", { 
            class: "team-impact-stats-container"
          }, [
            h("div", { class: "team-impact-stats-row" }, [
              h("small", { class: "text-muted" }, `${this.total} ${this.total === 1 ? 'Bewertung' : 'Bewertungen'}`),
              this.average > 0
                ? h("span", { 
                    class: `badge badge-${this.getAverageColor()} team-impact-badge`
                  }, this.getAverageLabel())
                : null,
            ])
          ])
        : null,
      
    ]);
  },
});
